var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "垂直排列方式" } },
        [
          _c(
            "el-select",
            {
              staticClass: "setting-grid-align",
              model: {
                value: _vm.align,
                callback: function($$v) {
                  _vm.align = $$v
                },
                expression: "align"
              }
            },
            [
              _c("el-option", { attrs: { value: "top", label: "顶部对齐" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "middle", label: "居中" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "bottom", label: "底部对齐" } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b10089d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b10089d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingGridAlign.vue
// module id = null
// module chunks = 